import { useState } from 'react';
import Icon from '../Icon.js';
import Theme from '../styles/Theme.js';
import Utils from '../Utils.js';

/*
 * OptionRow
 *
 * One selectable row. Used by the menus and by the escalation step, so a choice
 * looks like a choice wherever it is offered.
 *
 * Rows are buttons rather than radios: nothing here is being submitted, so the
 * radio's semantics would be describing a form that does not exist.
 */
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const OptionRow = ({
  help,
  icon,
  label,
  onClick
}) => {
  const [hover, setHover] = useState(false);
  const mobile = Utils.isMobile();
  return /*#__PURE__*/_jsxs("button", {
    onClick: onClick,
    onMouseEnter: setHover.bind(this, true),
    onMouseLeave: setHover.bind(this, false),
    style: {
      alignItems: 'center',
      backgroundColor: hover ? Theme.tint(0.05) : Theme.colors.white,
      border: `1px solid ${hover ? Theme.colors.primary() : Theme.colors.border()}`,
      borderRadius: 14,
      cursor: 'pointer',
      display: 'flex',
      gap: 14,
      padding: mobile ? '16px 16px' : '18px 20px',
      textAlign: 'left',
      transition: 'background-color 0.2s ease, border-color 0.2s ease',
      width: '100%'
    },
    children: [icon && /*#__PURE__*/_jsx(Icon, {
      color: Theme.colors.primary(),
      name: icon,
      size: 19,
      style: {
        flexShrink: 0
      }
    }), /*#__PURE__*/_jsxs("span", {
      style: {
        flexGrow: 1,
        minWidth: 0
      },
      children: [/*#__PURE__*/_jsx("span", {
        style: {
          ...Theme.textStyles.subHeading({
            fontSize: mobile ? 16 : 17
          }),
          display: 'block'
        },
        children: label
      }), help && /*#__PURE__*/_jsx("span", {
        style: {
          ...Theme.textStyles.body({
            fontSize: 14
          }),
          display: 'block',
          marginTop: 4
        },
        children: help
      })]
    }), /*#__PURE__*/_jsx(Icon, {
      color: hover ? Theme.colors.primary() : Theme.colors.lightGrey,
      name: 'arrow-right',
      size: 13,
      style: {
        flexShrink: 0
      }
    })]
  });
};
export default OptionRow;